import { createFileRoute, Outlet } from "@tanstack/react-router"

/** Agents: list (`/studio/agents`) and editor (`/studio/agents/$agentId`). */
export const Route = createFileRoute("/_app/studio/agents")({
  staticData: { titleKey: "nav.items.agents" },
  component: Outlet,
})
